'use es6';

import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import { jsx as _jsx } from "react/jsx-runtime";
const PermissionsError = () => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    className: "p-x-4",
    illustration: "keys",
    illustrationProps: {
      width: 200
    },
    title: /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universalSidebar.errors.PermissionsError.title"
      })
    }),
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universalSidebar.errors.PermissionsError.body"
      })
    })
  });
};
export default PermissionsError;